
export default function ContactInfo() {
  return (
    <div className="space-y-8">
      {/* Contact Information */}
      <div className="bg-gray-50 rounded-lg p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-6">Get in Touch</h3>
        
        <div className="space-y-4">
          <div className="flex items-start space-x-4">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-blue-600"></i>
            </div>
            <div>
              <h4 className="font-medium text-gray-900">Email</h4>
              <a 
                href="mailto:adsmarketing177@gmail.com"
                className="text-blue-600 hover:text-blue-700 transition-colors"
              >
                adsmarketing177@gmail.com
              </a>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-whatsapp-line text-green-600"></i>
            </div>
            <div>
              <h4 className="font-medium text-gray-900">WhatsApp</h4>
              <a 
                href="https://wa.me/919053492688"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-700 transition-colors"
              >
                +91 9053492688
              </a>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-time-line text-purple-600"></i>
            </div>
            <div>
              <h4 className="font-medium text-gray-900">Business Hours</h4>
              <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM</p>
              <p className="text-gray-600">Saturday: 10:00 AM - 4:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-gray-50 rounded-lg p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-6">Follow Us</h3>
        
        <div className="flex space-x-4">
          <a 
            href="https://www.facebook.com/mads.marketingads" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
          >
            <i className="ri-facebook-fill text-white text-xl"></i>
          </a>
          <a 
            href="https://www.instagram.com/mads_marketingads?igsh=MWI0N3lqODU1OHNpcQ%3D%3D&utm_source=q" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors"
          >
            <i className="ri-instagram-fill text-white text-xl"></i>
          </a>
        </div>
      </div>

      {/* Google Map */}
      <div className="bg-gray-50 rounded-lg p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-6">Our Location</h3>
        <div className="aspect-video rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.2233913121413!2d77.4051603706222!3d28.50292593193056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce626851f7009%3A0x621185133cfd1ad1!2sNoida%2C%20Uttar%20Pradesh%2C%20India!5e0!3m2!1sen!2sus!4v1647834536123!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Marketing Ads Location"
          ></iframe>
        </div>
        <p className="text-gray-600 mt-4 text-center">
          Noida, Uttar Pradesh, India
        </p>
      </div>
    </div>
  );
}
